const getters = {
  dynamic_routes: state => state.permission.routes,
  device_type:state => state.device.device_type,
  token:state => state.user.token
}
export default getters
